import React, {Component} from 'react';
import AdminHomeTableStudy from './admin-home-table-study';

class AdminHomeTableStudies extends Component{

    componentDidMount() {
      }

    render(){

        return(


            <div className="tab-pane fade" id="studies" role="tabpanel">
                <div className="studies-tables-admin">
                    <h2 className="studies-title">كل الدراسات </h2>
                    <table className="table studies-table-admin table-responsive-md">
                        <thead>
                            <tr>
                                <th>اسم الدراسة</th>
                                <th>التاريخ</th>
                                <th>الوقت</th>
                                <th>العميل</th>
                                <th>التكلفة</th>
                                <th>المهام</th>
                            </tr>
                        </thead>
                        <tbody>
                            <AdminHomeTableStudy studyName={"دراسة مشروع ناقلات"} studyDate={"27/1/2021"} studyTime= {"3:15"} studyClient={"شركة الشحن"} studyCost={"12,000 ر.س"}/>
                            <AdminHomeTableStudy studyName={"دراسة مشروع ناقلات"} studyDate={"27/1/2021"} studyTime= {"3:15"} studyClient={"شركة الشحن"} studyCost={"12,000 ر.س"}/>
                            <AdminHomeTableStudy studyName={"دراسة مشروع ناقلات"} studyDate={"27/1/2021"} studyTime= {"3:15"} studyClient={"شركة الشحن"} studyCost={"12,000 ر.س"}/>
                            <AdminHomeTableStudy studyName={"دراسة مشروع ناقلات"} studyDate={"27/1/2021"} studyTime= {"3:15"} studyClient={"شركة الشحن"} studyCost={"12,000 ر.س"}/>
                            <AdminHomeTableStudy studyName={"دراسة مشروع ناقلات"} studyDate={"27/1/2021"} studyTime= {"3:15"} studyClient={"شركة الشحن"} studyCost={"12,000 ر.س"}/>
                            <AdminHomeTableStudy studyName={"دراسة مشروع ناقلات"} studyDate={"27/1/2021"} studyTime= {"3:15"} studyClient={"شركة الشحن"} studyCost={"12,000 ر.س"}/>
                        </tbody>
                    </table>
                </div>
               
        </div>
            
        );
       
    }

};
export default AdminHomeTableStudies;


